export default __webpack_public_path__ + "static/uber.url-b4618d160eac20bd69fe74c27e68111b.svg";